import React, { FC, ReactNode } from 'react';
import { Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from 'src/e2e-redesign/theme';
import ThemedContainer from 'src/e2e-redesign/components/ThemedContainer';

interface AggregatorLayoutProps {
  children: ReactNode;
}

const AggregatorLayout: FC<AggregatorLayoutProps> = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          minHeight: '100vh', 
          width: '100%',
          overflowX: 'auto', // Allow horizontal scrolling if needed
          overflowY: 'auto', // Allow vertical scrolling
        }}
      >
        <ThemedContainer sx={{ flexGrow: 1, overflow: 'visible' }}>{children}</ThemedContainer>
      </Box>
    </ThemeProvider>
  );
};

export default AggregatorLayout;
